import angular from 'angular';

// TODO(angular-1.4): This directive would be AMAZING if it came with some
// default testimonials out of theo box. This is easy in angular 1.4 with
// optional transclusion. All we have to do is put the default testimonials
// within the `ng-transclude` in `od-testimonial-block.html.slim`, and they
// will be a fallback if no testimonials are passed in.
//
// Unfortunately, doing this before Angular 1.4 results in double-registration
// bugs that confuse the carousel. It's probably possible to hack around, but
// I'd rather wait for now.
//
// TODO(azirbel): Auto-advance to next quote automatically, at a set interval.
// Unfortunately, this is a bit hard because our carousels aren't circular.
module.exports = angular.module('common.directives.od-testimonial-block', [])
.directive('odTestimonialBlock', () => {
  return {
    restrict: 'EA',
    scope: {},
    templateUrl: '/templates/common/directives/od-testimonial-block.html',
    transclude: true
  };
})
.directive('odTestimonial', () => {
  return {
    restrict: 'EA',
    require: '^odCarousel',
    scope: {
      byline: '@'
    },
    templateUrl: '/templates/common/directives/od-testimonial.html',
    transclude: true,
    link: (scope, elem, attrs, odCarousel) => {
      elem[0].setAttribute('od-carousel-item', true);
      odCarousel.debouncedRebuild();
    }
  };
})
.name;



/** WEBPACK FOOTER **
 ** ./javascripts/common/directives/od-testimonial-block.js
 **/